export default {
    apiKey: "AIzaSyBtmpEAmgxFmsMjTqWRBj7YH4hqgoQ_tIw",
    authDomain: "tallyjofficer.firebaseapp.com",
    databaseURL: "https://tallyjofficer.firebaseio.com",
    projectId: "tallyjofficer",
    storageBucket: "tallyjofficer.appspot.com",
    messagingSenderId: "622078480604"
}